import {
  DASHBOARD_PERIOD_OPTIONS,
  dashboardPeriodLabel,
  type DashboardPeriodFilter,
  type DashboardPeriodSelection
} from '../shared/utils/dashboard-period-filter.util';

/** Period presets aligned with the main Revenue dashboard. */
export const PAYMENTS_PERIOD_OPTIONS = DASHBOARD_PERIOD_OPTIONS;

export type PaymentsPeriodFilter = DashboardPeriodFilter;

export type PaymentsPeriodSelection = DashboardPeriodSelection;

const LEGACY_PERIOD_MAP: Record<string, PaymentsPeriodFilter> = {
  today: 'today',
  yesterday: 'today',
  last7Days: 'week',
  thisWeek: 'week',
  week: 'week',
  last30Days: 'month',
  last6Months: 'month',
  thisMonth: 'month',
  month: 'month',
  lastMonth: 'month',
  thisYear: 'year',
  year: 'year',
  custom: 'Custom',
  Custom: 'Custom'
};

export function normalizePaymentsPeriod(value: string | null | undefined): PaymentsPeriodFilter {
  if (!value) return 'today';
  const trimmed = value.trim();
  if (trimmed.startsWith('Custom')) return 'Custom';
  const mapped = LEGACY_PERIOD_MAP[trimmed];
  if (mapped) return mapped;
  return PAYMENTS_PERIOD_OPTIONS.some(option => option.value === trimmed)
    ? (trimmed as PaymentsPeriodFilter)
    : 'today';
}

export function paymentsPeriodLabel(value: string | null | undefined): string {
  return dashboardPeriodLabel(normalizePaymentsPeriod(value));
}

export function restorePaymentsPeriodSelection(
  saved?: PaymentsPeriodSelection | { value?: string; period?: string; startDate?: string; endDate?: string } | null
): { period: PaymentsPeriodFilter; startDate?: string; endDate?: string } {
  const raw = saved?.period ?? (saved as any)?.value;
  const period = normalizePaymentsPeriod(raw);
  if (period === 'Custom' && saved?.startDate && saved?.endDate) {
    return {
      period,
      startDate: String(saved.startDate),
      endDate: String(saved.endDate)
    };
  }
  return { period: period === 'Custom' ? 'today' : period };
}
